import { inject, Injectable } from '@angular/core';
import { apiUrls } from '@easy-lib/constants';
import { EasyEnvironment } from '@easy-lib/modules/shared/models';
import { posthog } from 'posthog-js';
// eslint-disable-next-line @typescript-eslint/ban-types
declare let gtag: Function;

@Injectable({
	providedIn: 'root'
})
export abstract class GtagService {
	private environment: EasyEnvironment = inject(EasyEnvironment);

	constructor() {
		if (this.environment.postHog.active) {
			posthog.init(this.environment.postHog.token, {
				api_host: this.environment.postHog.url
			});
		}
	}
	private urlCategoryExtractor(url: string) {
		url = url.replace(this.environment.setting.mtspath, '');
		let module,
			modulefull = '';
		let requestName = '';
		const apiUrlKeys = Object.values(apiUrls);
		if (apiUrlKeys.some(x => url.includes(x))) {
			modulefull = apiUrlKeys.find(x => url.includes(x));
			module = apiUrlKeys.find(x => url.includes(x)).split('/')[0];
			const rest = url.replace(modulefull, '').split('?');
			requestName = rest.length ? rest[0] : '';
			if (requestName.includes('/IR')) {
				requestName = requestName.split('/IR')[0];
			}
		}
		if (!module || !requestName) {
			if (url.includes('/')) {
				module = url.split('/')[0];
				requestName = url.split('/')[1];
			} else {
				module = url;
				requestName = url;
			}
		}
		return { module, requestName };
	}
	sendApiRequestTypr(url, info) {
		if (info.latency >= 1) {
			info.latency = Math.round(info.latency);
		}
		const urlObject = this.urlCategoryExtractor(url);
		if (urlObject.requestName.includes('server-time')) return;
		gtag('event', 'request', { ...urlObject, ...info });
		if (this.environment.postHog.active) {
			posthog.capture('request', { ...urlObject, ...info });
		}
	}

	sendGtagEvent(eventName: string, eventKey?: string, eventValue?: string): void {
		if (eventKey) gtag('event', eventName, { eventKey: eventValue });
		else gtag('event', eventName);
	}
}
